import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from 'moment';

import { boardsActions } from '../../../store/boards';
import { Panel, PanelHeader } from '../../../components/admin/panel/panel';
import { breadcrumb } from '../../../helpers/page-admin';
import 'react-table/react-table.css';

class Boards extends React.Component {

    constructor(props) {
        super(props);
        this.state = ({
            ...this.props,
        });

        this.category = this.props.match.params.c;
        this.subCategory = this.props.match.params.s;

        this.defaultSorted = [
            {
                id: "boardId",
                desc: true
            }
        ];
        this.tableColumns = [
            {
                Header: "정보",
                columns: [
                    {
                        Header: "ID",
                        accessor: "boardId",
                        maxWidth: 100,
                        className: 'text-center',
                    },
                    {
                        Header: "제목",
                        accessor: 'title',
                        Cell: row => (
                            <Link className='g-default-color' to={{
                                pathname: `/admin/boards/details/${row.original.boardId}`,
                                state: { panelTitle: this.panelTitle, ...row.original },
                            }} > { row.value }</Link >
                        ),
                    }
                ]
            },
            {
                Header: '상태',
                columns: [
                    {
                        Header: "공개",
                        accessor: "enabled",
                        maxWidth: 120,
                        Cell: row => (
                            <div className="text-center">
                                <div className="switcher">
                                    {
                                        //console.log(row.original.boardId + " : " + row.original.enabled + " : " + row.original.fixed)
                                    }
                                    <input checked={row.original.enabled} onChange={event => this.onChange(event)} type="checkbox" name={`checkbox_enabled_${row.original.boardId}`} id={`checkbox_enabled_${row.original.boardId}`} />
                                    <label htmlFor={`checkbox_enabled_${row.original.boardId}`}></label>
                                </div>
                            </div>
                        ),
                    },
                    {
                        Header: "공지",
                        accessor: "fixed",
                        maxWidth: 120,
                        Cell: row => (
                            <div className="text-center">
                                <div className="switcher">
                                    <input checked={row.original.fixed} onChange={event => this.onChange(event)} type="checkbox" name={`checkbox_fixed_${row.original.boardId}`} id={`checkbox_fixed_${row.original.boardId}`} />
                                    <label htmlFor={`checkbox_fixed_${row.original.boardId}`}></label>
                                </div>
                            </div>
                        ),
                    },
                    {
                        id: 'time',
                        Header: '등록일',
                        accessor: d => moment(d.time).format("YYYY-MM-DD hh:mm"),
                        maxWidth: 170,
                        className: 'text-center',
                    },
                    {
                        filterable: false,
                        Header: '',
                        accessor: 'boardId',
                        Cell: row => (
                            <div className="text-center">
                                <button onClick={event => { if (window.confirm('정말로 삭제하시겠습니까?')) this.onClickDelete(event, row.value) }} className="btn btn-grey btn-xs rounded-0 m-r-5 m-t-minus-5">삭제</button>
                                <button onClick={event => this.onClickUpdate(event, row.original)} className="btn btn-inverse btn-xs rounded-0 m-r-5 m-t-minus-5">수정</button>
                            </div>
                        ),
                        maxWidth: 120
                    }
                ]
            }
        ]
    }

    componentDidMount() {
        this.props.getBoards(this.category, this.subCategory);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.boards !== nextProps.boards) {
            return { boards: nextProps.boards };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        // This method is called when the route parameters change
        const mc = this.props.match.params.c;
        const ms = this.props.match.params.s;
        if (this.category !== mc || this.subCategory !== ms) {
            this.category = mc;
            this.subCategory = ms;
            this.props.getBoards(mc, ms);
        }
    }

    onChange = (event) => {
        const name = event.target.name.split('_')[1];
        const id = event.target.name.split('_')[2];
        this.props.checkBoard(name, id);
    }

    onClickCreate = (event) => {
        event.preventDefault();
        this.props.history.push({
            pathname: `/admin/boards/create/${this.category}/${this.subCategory}`,
            state: { panelTitle: this.panelTitle }
        });
    }

    onClickUpdate = (event, board) => {
        event.preventDefault();
        this.props.history.push({
            pathname: `/admin/boards/update/${board.boardId}`,
            state: { panelTitle: this.panelTitle, ...board }
        });
    }

    onClickDelete = (event, id) => {
        event.preventDefault();
        if (id) this.props.deleteBoard(id);
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <button onClick={event => this.onClickCreate(event)} className="btn btn-danger btn-sm"><i className="fa fa-plus"></i> 신규등록</button>
                </div>
                <Panel>
                    <PanelHeader>{breadcrumb(this.props).title} 리스트</PanelHeader>
                    <ReactTable className="-highlight"
                        filterable
                        data={this.state.boards}
                        columns={this.tableColumns}
                        defaultPageSize={10}
                        defaultSorted={this.defaultSorted}
                        loading={this.props.isLoading}
                        previousText='이전' nextText='다음' />
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Boards));


// WEBPACK FOOTER //
// ./src/pages/admin/boards/index.js